import { render, staticRenderFns } from "./KnFormOrder.vue?vue&type=template&id=4b5c1b0c"
import script from "./KnFormOrder.js?vue&type=script&lang=js&external"
export * from "./KnFormOrder.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports